class AlgoliaIconCheckboxChecked extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconCheckboxCheckedUrl: this.getAttribute('default-icon-checkbox-checked-url'),
      iconCheckboxCheckedSize: this.getAttribute('icon-checkbox-checked-size'),
      iconCheckboxCheckedUrl: this.getAttribute('icon-checkbox-checked-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-checkbox-checked {
        background-image: url(${this.settings.iconCheckboxCheckedUrl ? this.settings.iconCheckboxCheckedUrl : this.settings.defaultIconCheckboxCheckedUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconCheckboxCheckedSize}%;
        height: 100%;
        width: 100%;
      }
    `;
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon-checkbox-checked');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = " ";
    
    return [style, div];
  }
}

customElements.define("algolia-icon-checkbox-checked", AlgoliaIconCheckboxChecked);